import { render, staticRenderFns } from "./ReferralsBase.vue?vue&type=template&id=19ad5479"
import script from "./ReferralsBase.vue?vue&type=script&lang=js"
export * from "./ReferralsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports